import Content from './components/Content';
import Hero from './components/Hero';
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';
import Partners from './components/Partners';

function App() {
  return (
    <>
      <NavigationBar />
      <Hero />
      <Content />
      <Partners />
      <Footer />
    </>
  );
}
export default App;